import { render, staticRenderFns } from "./DeviceCreateView.vue?vue&type=template&id=4740fb18&"
import script from "./DeviceCreateView.vue?vue&type=script&lang=ts&"
export * from "./DeviceCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports